<template>
    <div v-if="qrCodeURL">
        <qrcode-vue :value="qrCodeURL" :size="size" level="H" v-if="supply === 'รับหน้าร้าน' ||  supply === 'coupon' || (supply === 'link_code' && rewardCode.search('/') === -1)"></qrcode-vue><br>
        <v-row>
            <v-col cols="12" class="px-7" v-if="supply === 'รับหน้าร้าน' || supply === 'coupon'">
                <v-text-field
                v-model="rewardCode"
                :label="$t('message.rewardCode')"
                ref="textToCopyformView"
                outlined
                dense
                readonly
                ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              align="center"
              v-else-if="
                supply === 'link_code' &&
                !rewardCode.startsWith('http') && rewardCode.search('/') === -1
              "
            >
              <v-text-field
                v-model="rewardCode"
                ref="textToCopy"
                outlined
                style="width: 220px"
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              align="center"
              class="pt-0"
              v-if="
                supply === 'link_code' &&
                !rewardCode.startsWith('http') && rewardCode.search('/') !== -1
              "
            >
              <v-text-field
                v-model="rewardCode.split('/')[0]"
                label="user"
                ref="textToCopy"
                outlined
                style="width: 220px"
                dense
                hide-details
                class="mb-3"
              ></v-text-field>
              <v-text-field
                v-model="rewardCode.split('/')[1]"
                label="password"
                ref="textToCopy"
                outlined
                style="width: 220px"
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              align="center"
              class="pa-0 mb-2"
              v-else-if="
                supply === 'link_code' &&
                rewardCode.startsWith('http')
              "
            ><a :href="rewardCode"
                >*{{ rewardCode }}</a
            ></v-col
            >
            <!-- <v-col class="text-center" cols="1" xs="1" sm="1" md="1" lg="1">
                <v-btn :color="$bgColor2"
                fab
                x-small
                dark @click="copyTextformView"><v-icon>mdi-content-copy</v-icon></v-btn>
            </v-col> -->
        </v-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'
export default {
  name: 'QRCodeUseCode',
  props: ['rewardId', 'rewardCode', 'lineUserId', 'memberId', 'supply'],
  components: {
    QrcodeVue
  },
  data () {
    return {
      member: null,
      profile: null,
      qrCodeURL: null,
      size: 150,
      shopId: null
    }
  },
  async mounted () {
    this.shopId = this.GET_SHOPID()
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    if (this.shopId !== 'SD_1737957295593') {
      this.qrCodeURL = this.ADMIN_IP + `/Master/trade?shopId=${this.shopId}&rewardId=${this.rewardId}&rewardCode=${this.rewardCode}&memberId=${this.profile.memberId}`
    } else {
      this.qrCodeURL = this.rewardCode
    }
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    copyTextformView () {
      let textToCopyformUpdate = this.$refs.textToCopyformView.$el.querySelector('input')
      textToCopyformUpdate.select()
      document.execCommand('copy')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QRCodeUseCode.vue